<template>
  <v-app :style="cssProps">
    <v-toolbar fixed app class="white" :dense="dense">
      <v-layout>

        <v-flex xs4 md4 hidden-sm-and-down>
          <v-layout align-center fill-height>

            <v-btn flat href="tel:+77072333888">
              <font-awesome-icon :icon="['fab', 'whatsapp']" class="v-icon v-icon--left red--text text--darken-4" />+7 (707) 233 38 88
              <!-- <v-icon left color="red darken-4">fab fa-whatsapp</v-icon>+7 (702) 422 45 67 -->
            </v-btn>

          </v-layout>
        </v-flex>

        <v-flex xs12 md4>
          <v-layout justify-center align-center fill-height>
            <router-link to="/" d-flex justify-center align-center :class="[ 'logo-link', { 'logo-link_dense': logo.denseClass }]">
              <img
                :class="[ logo.class, { logo_dense: logo.denseClass }]"
                alt="cayenne.kz"
                v-lazy="require(`@/assets/img/logo.png`)"
              >
            </router-link>
          </v-layout>
        </v-flex>

        <v-flex xs4 md4 hidden-sm-and-down>
          <v-layout justify-end align-center fill-height>

            <template v-if="page === 'service'">
              <send-phone-number  v-if="!pageDialog" :flat="true"></send-phone-number>
              <v-btn flat to="/" @click="setPage('parts')">
                <font-awesome-icon icon="angle-left" class="v-icon v-icon--left red--text text--darken-4" />
                Запчасти
              </v-btn>
            </template>

            <template v-else>
              <send-vincode  v-if="!pageDialog" :flat="true"></send-vincode>
              <v-btn flat to="service" @click="setPage('service')">
                Автосервис
                <font-awesome-icon icon="angle-right" class="v-icon v-icon--right red--text text--darken-4" />
              </v-btn>
            </template>

          </v-layout>
        </v-flex>

        <v-flex class="menu-toggle" hidden-md-and-up>
          <v-layout align-center fill-height>
            <v-btn fab small dark color="red darken-4" @click.stop="drawer = !drawer" class="ma-1 pa-2">
              <font-awesome-icon icon="bars" class="v-icon d-flex align-center theme--dark" />
            </v-btn>
          </v-layout>
        </v-flex>

      </v-layout>
    </v-toolbar>

    <v-navigation-drawer
      v-model="drawer"
      fixed
      temporary
    >

      <v-layout justify-center wrap>

        <v-flex xs12 class="d-flex justify-space-between">
          <v-btn href="tel:+77072333888" class="my-3">
            <font-awesome-icon :icon="['fab', 'whatsapp']" class="v-icon v-icon--left red--text text--darken-4" />+7 (707) 233 38 88
          </v-btn>
        </v-flex>

        <template v-if="page === 'service'">
            <send-phone-number v-if="!pageDialog" class="d-flex"></send-phone-number>
          <v-flex xs12 class="d-flex justify-space-between">
            <v-btn to="/" @click="setPage('parts')">Запчасти</v-btn>
          </v-flex>
        </template>
        <template v-else>
            <send-vincode v-if="!pageDialog" class="d-flex"></send-vincode>
          <v-flex xs12 class="d-flex justify-space-between">
            <v-btn to="service" @click="setPage('service')">Автосервис</v-btn>
          </v-flex>
        </template>

      </v-layout>
    </v-navigation-drawer>

    <v-content v-scroll="onScroll">

      <v-flex xs12>
        <swiper :options="swiperOption">
          <swiper-slide v-for="item in images" :key="item.id">
            <img
              v-lazy="item.src"
              class="swiper-image"
              :alt="`Запчасти ${item.id}`"
            >
          </swiper-slide>

          <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
          <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
          <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        </swiper>
      </v-flex>

      <page-transition>
          <router-view></router-view>
      </page-transition>

      <two-gis-map></two-gis-map>

    </v-content>

    <v-footer dark height="auto" class="py-4">
      <v-layout wrap>
        <v-flex xs12 sm4>
          <v-layout fill-height justify-center align-center>
            <span>&copy; {{ footerDate }} cayenne.kz</span>
          </v-layout>
        </v-flex>

        <v-flex xs12 sm4>
          <v-layout fill-height justify-center align-center>
            <a href="https://www.instagram.com/cayenne.kz/" target="_blank">
              <font-awesome-icon :icon="['fab', 'instagram']" class="v-icon" size="2x"/>
            </a>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-footer>

    <v-dialog
      v-model="pageDialog"
      persistent
      max-width="400"
    >

      <v-card>

        <v-card-text>

          <v-flex xs12>
            <v-layout fill-height justify-center align-center wrap>

              <router-link class="svg-link" to="/" @click.native="setPage('parts', false)">
                <svg height="100%" width="100%" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="50" cy="50" r="49" class="outline" height="100%" width="100%" />
                  </svg>
                  <svg class="svg-link__img">
                    <use xlink:href="./assets/svg/disc-brake.svg#db"></use>
                  </svg>
                  <div class="svg-link__text">Запчасти</div>
              </router-link>

              <router-link class="svg-link" to="service" @click.native="setPage('service', false)">
                <svg height="100%" width="100%" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="50" cy="50" r="49" class="outline" height="100%" width="100%" />
                </svg>
                <svg class="svg-link__img">
                  <use xlink:href="./assets/svg/wrench-and-screwdriver-cross.svg#was"></use>
                </svg>
                <div class="svg-link__text">Автосервис</div>
              </router-link>

              <router-link class="banner-link" to="service" @click.native="setPage('service', false)">
                <img
                  class="banner-image"
                  alt="cayenne.kz"
                  v-lazy="require(`@/assets/img/banner.jpg`)"
                >
              </router-link>

            </v-layout>

          </v-flex>

        </v-card-text>

      </v-card>

    </v-dialog>

  </v-app>
</template>

<script>
// import SendVincode from '@/components/parts/SendVincode.vue'
// import SendPhoneNumber from '@/components/service/SendPhoneNumber.vue'
const SendVincode = () => import('@/components/parts/SendVincode.vue')
const SendPhoneNumber = () => import('@/components/service/SendPhoneNumber.vue')
const twoGisMap = () => import('@/components/Map.vue')
// const PageTransition = () => import('@/components/PageTransition.vue')
import PageTransition from '@/components/PageTransition.vue'
import colors from 'vuetify/es5/util/colors'
import {EventBus} from '@/plugins/eventbus.js'

export default {
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    // title: 'Default Title',
    // all titles will be injected into this template
    titleTemplate: '%s | Cayenne.kz'
  },
  components: {
    SendVincode,
    SendPhoneNumber,
    PageTransition,
    twoGisMap
  },
  data() {
    return {
      offsetTop: 0,
      drawer: false,
      dense: false,
      fixed: true,
      date: null,
      serviceDialog: false,
      logo: {
        class: "logo",
        denseClass: false
      },
      items: [
        { icon: "apps", title: "Welcome", to: "/" },
        { icon: "bubble_chart", title: "Inspire", to: "/inspire" },
        { icon: "settings", title: "Admin", to: "/admin" },
        { icon: "person", title: "Users", to: "/admin/users" }
      ],
      swiperOption: {
        // spaceBetween: 30,
        // preloadImages: false,
        //  lazy: {
        //   loadPrevNext: true,
        // },
        effect: "slide",
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  mounted() {
  },
  computed: {
    footerDate() {
      return new Date().getFullYear();
    },
    page() {
      this.$store.getters["getPage"] === '' ? this.setPageDialog(true) : this.setPageDialog(false)
      return this.$store.getters["getPage"]
    },
    pageDialog() {
      return this.$store.getters["getPageDialog"]
    },
    cssProps () {
      return {
        '--red-color': colors.red.darken4
      }
    },
    images() {
      let images = [];
      for (let i = 1; i < 13; i++) {
        images.push({ id: i, src: require(`@/assets/img/cayenne/cayenne${i}.jpg`) });
      }
      images.sort(function() { return 0.5 - Math.random() });
      return images;
    },
  },
  methods: {
    // ...mapMutations({
    //   logout: "logout",
    //   setPage: 'page/setPage'
    // }),
    setPage(page, bool) {
      if (this.pageDialog) {
        EventBus.$emit('initMap');
      }
      this.setPageDialog(bool)
      this.$store.dispatch('setPage', page)
    },
    setPageDialog(bool) {
      this.$store.dispatch('setPageDialog', bool)
    },
    selectPage(pageName) {
      this.pageDialog = false
      this.setPage(pageName)
      if (this.page === 'parts') {
        this.$router.push('/')
      } else {
        this.$router.push(pageName)
      }
    },
    onScroll(e) {
      this.offsetTop = window.pageYOffset || e.target.scrollTop;
      if (this.offsetTop > 0) {
        this.dense = true;
        this.logo.denseClass = true;
      } else {
        this.dense = false;
        this.logo.denseClass = false;
      }
    }
  },
};
</script>

<style lang="stylus">
  @import "./stylus/fonts.styl"
  @import "./stylus/vars.styl"

  img
    width 100%

  .v-toolbar
    z-index 3
    &__content
      transition all 0.25s ease

  .v-content
    z-index 0

  .logo
    width: 100px
    transition: all 0.25s ease
    &_dense
      width: 70px

    &-link
      padding: 0 16px
      background-color #fff
      &:before
        content: ''
        position: absolute
        top: 29px
        left: 2%
        right: 2%
        height: 1px
        transition: all .2s
        background: linear-gradient(to left, transparent 10%, #dfdfdf 80%, transparent 90%)
        z-index: -1
      &_dense
        &:before
          top: 21px

  .menu-toggle
    position fixed
    top 0
    right 16px

  .v-btn
    .v-icon
      margin-top: -3px

  .v-chip.chip
    align-items center
    border-radius 28px
    display inline-flex
    font-size 13px
    margin 4px
    outline none
    position: relative
    transition 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)
    vertical-align middle
    padding 5px 20px
    z-index 3
    background-color #212121
    text-decoration none
    font-family $default-font
    font-weight bold
    font-size 14px

    &-absolute
      position absolute
      top 5px
      right 0

    span

      &:nth-child(1)
        text-transform uppercase
        margin-right 2px

      &:nth-child(2)
        color #fff
        margin-right 12px

      &:nth-child(3)
        font-family $lobster-font
        color #fff
        letter-spacing 1px

    &:hover
      background-color rgba(#212121, .8)

  @media only screen and (max-width: 960px)
    .logo
      width: 70px
      //&-link
      //  &:before
      //    top 37px

</style>

<style lang="stylus" scoped>

  .swiper-button-prev,
  .swiper-button-next
    opacity 0
    transition all .25s ease

  .swiper-container
    height calc(100vh - 238px)

  .swiper-image
    height calc(100vh - 238px)
    width 100%
    object-fit cover
    object-position center center


  .swiper-container:hover
    .swiper-button-prev,
    .swiper-button-next
      opacity 1

  .v-content
    transition: all 0.25s ease

  .v-toolbar__content
    transition: all 0.25s ease

  .svg-link
    display block
    position relative
    color #000
    text-decoration: none
    width 100px
    height 100px
    margin 10px 10px 34px 10px
    // overflow: hidden

    .outline
      position absolute
      top 0
      left 0
      width 100%
      height 100%
      border-radius 50%
      stroke #000
      stroke-width 2px
      fill transparent
      stroke-dasharray 25 25
      stroke-dashoffset -588
      transition .5s ease

    .text
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)

    &:hover
      .outline
        stroke var(--red-color)
        stroke-dasharray 50 50
        stroke-dashoffset -275

      .svg-link__text
        color var(--red-color)

      .svg-link__img
        fill var(--red-color)

    &__img
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)
      width 50px
      height 50px
      transition .5s ease

    &__text
      position absolute
      top 115px
      width 100%
      text-align center
      font-size 16px
      transition .5s ease

  .banner
    &-link
      margin-top 15px
      overflow hidden
      border-radius 2px

</style>
